module.exports = __webpack_public_path__ + "img/CorneliusComposerLogo.77e220c1.png";